<template>
    <div class="page accauntInfoPage">
        <form  @submit.prevent="saveAccInfo(user)">
            <div class="container" v-if="form">
                <div class="row">
                    <h3 class="col-12 mediaHideOnDesctop">
                        <div class="accTitle mediaHideOnDesctop">
                            <span>General Information</span>
                            <div @click="$store.dispatch('user/logout')">Logout</div>
                        </div>
                    </h3>
                    <div class="descktopMediaBox col-12">
                        <div class="h1" v-if="updatePassword">
                            Create your new password
                        </div>
                        <div class="h1" v-else>
                            Profile
                        </div>
                    </div>
                    <div class="formContainer col-12">
                        <div class="popupForm" v-if="updatePasswordPopup">
                            <div class="closeThis" @click="updatePasswordPopup=false">
                                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M6.98026 0.971802C3.3956 0.971802 0.498047 3.8049 0.498047 7.30983C0.498047 10.8148 3.3956 13.6479 6.98026 13.6479C10.5649 13.6479 13.4625 10.8148 13.4625 7.30983C13.4625 3.8049 10.5649 0.971802 6.98026 0.971802ZM10.2214 9.58518L9.30738 10.4788L6.98026 8.20349L4.65315 10.4788L3.73915 9.58518L6.06627 7.30983L3.73915 5.03448L4.65315 4.14082L6.98026 6.41617L9.30738 4.14082L10.2214 5.03448L7.89425 7.30983L10.2214 9.58518Z"
                                        fill="black"/>
                                </svg>
                            </div>
                            
                            <md-field class="formRow md-focused" :class="updatePassword ? 'showLabel' : ''">
                                <label>New Password</label>
                                <md-input minlength="4" class="" v-model="form.password" type="password" placeholder=""></md-input>
                            </md-field>
                            <md-field class="formRow md-focused" :class="updatePassword ? 'showLabel' : ''">
                                <label>Confirm New Password</label>
                                <md-input minlength="4" class="" v-model="form.passwordconfirm" type="password" placeholder=""></md-input>
                            </md-field>
                            <button class="zbg mt-4">Save</button>
                        </div>
                        <div class="formRow" v-if="!updatePassword">
                            <label class="mediaHideOnDesctop" for="fname">Your First Name</label>
                            <input
                                type="text"
                                class="form-control"
                                id="fname"
                                placeholder="First Name*"
                                required
                                v-model="form.first_name"
                            >
                        </div>
                        <div class="formRow" v-if="!updatePassword">
                            <label class="mediaHideOnDesctop" for="lname">Your Last Name</label>
                            <input
                                type="text"
                                class="form-control"
                                id="lname"
                                placeholder="Last Name*"
                                required
                                v-model="form.last_name"
                            >
                        </div>
                        <div class="formRow" v-if="!updatePassword">
                            <label class="mediaHideOnDesctop" for="email">Email</label>
                            <input
                                type="email"
                                id="email"
                                class="form-control"
                                placeholder="Email*"
                                required
                                v-model="form.email"
                            >
                        </div>
                        <div @click="!updatePassword ? updatePasswordPopup=!updatePasswordPopup : ''">
                        <md-field class="formRow md-focused" :class="updatePassword ? 'showLabel' : ''" v-if="updatePassword">
                            <label>Password</label>
                            <md-input minlength="4" class="" v-model="form.password" type="password" :placeholder="!updatePassword ? '*********' : 'Password'"></md-input>
                        </md-field>
                        </div>
                        <md-field class="formRow md-focused" :class="updatePassword ? 'showLabel' : ''" v-if="updatePassword">
                            <label>Confirm Password</label>
                            <md-input minlength="4" class="" v-model="form.passwordconfirm" type="password" placeholder="Confirm Password"></md-input>
                        </md-field>
                        <div class="formRow" v-if="!updatePassword">
                            <label class="mediaHideOnDesctop" for="phone">Phone</label>
                            <!--<input
                                class="form-control"
                                placeholder="Phone*"
                                id="phone"
                                required
                                v-model="form.phone"
                            >-->
                            <VuePhoneNumberInput required :no-use-browser-locale="true" id="phone" @update="onUpdatePhone" v-model="form.phone"/>
                        </div>
                        <div class="formRow" :class="user.date_of_birth?'disthis':''" v-if="!updatePassword">
                            <label class="mediaHideOnDesctop" for="phone">Birthday</label>
                            <md-datepicker v-model="form.date_of_birth" disabled md-immediately @md-opened="$refs.mkDatePicker.$el.querySelector('input').blur()" ref="mkDatePicker"/>
                        </div>
                        
                        <h3 v-if="!updatePassword" class="red" @click="updatePasswordPopup=!updatePasswordPopup">change password</h3>
                        
                        <div class="cardBox" v-if="!updatePassword">
                            <h3>Contact Preferences</h3>
                            <div class="formRow nbrd checBox">
                                <md-checkbox v-model="form.notifications">I consent to receiving emails from Kettleman’s</md-checkbox>
                            </div>
                            <h3>Cards</h3>
                            <div class="linkList">
                                <div class="ktcards listEl">
                                    <router-link :to="{name: 'ManageCards'}" >
                                        <div class="icon">
                                            <img :src="getStaticImage('icons/cardIcon.png')">
                                        </div>
                                        <div class="text h3">
                                            Kettleman’s Cards
                                        </div>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                       
                    </div>
                </div>
            </div>
            <div class="botBtn">
                <div class="container">
                    <button class="zbg mb-4">Save</button>
                </div>
                <div class="container">
                    <a class="btnlink zbg" :href="del_url">Request account removal</a>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import moment from "moment";
    import 'vue-phone-number-input/dist/vue-phone-number-input.css';
    
    export default {
        name: "AccauntInfomation",
        data(){
            return{
                form: null,
                notification: null,
                phonePayload: null,
                updatePassword: false,
                del_url: null,
                updatePasswordPopup: false,
            }
        },
        created() {
            this.$store.commit("shared/setTopBar", {title: "Account Info", showBackButton: false, showBag: false});
            
            this.updatePassword = this.user.must_update_password;
            
            if (this.user.date_of_birth){
                let dateParts = this.user.date_of_birth.split('/');
                if(dateParts[0].length > 4){
                    this.user.date_of_birth =  moment(this.user.date_of_birth, 'YYYY-MM-DD').format('MM/DD/YYYY');
                }
            }
            
            
            this.notification = this.$store.state.user.notificationState;
            this.$store.dispatch("user/getNotificationState",{
                callback: () => {
                    this.form.notifications  = this.$store.state.user.notificationState;
                }
            });
            //console.log(this.user);
            let phone = this.user.phone;
            if(this.user.country_code){
                phone = "+"+this.user.country_code+this.user.phone;
                //console.log(phone);
            }
            this.form = {
                first_name: this.user.first_name,
                last_name: this.user.last_name,
                email: this.user.email,
                date_of_birth: this.user.date_of_birth,
                phone: phone,
                password: this.user.password,
                notifications: this.notification
            }
            this.del_url = "mailto:hello@kettlemansbagel.ca?subject=Account%20deletion%20request&body=Account%20deletion%20request%20member_id%20=%20"+this.user.member_id+";%20phone%20=%20"+this.user.phone;
        },
        methods:{
            saveAccInfo(val){
                //console.log(this.form)
                if(this.updatePassword || this.updatePasswordPopup){
                    if(this.form.passwordconfirm === this.form.password){
                        this.$store.dispatch("user/updateUserInformation", {...this.form})
                        this.updatePasswordPopup = false;
                    }else{
                        this.$store.commit("shared/setAlert", "The password field and the password confirmation field must be the same.");
                    }
                }else{
                    this.$store.dispatch("user/updateUserInformation", {...this.form})
                }
            },
            onUpdatePhone (payload) {
                this.phonePayload = payload;
                if(payload.countryCallingCode){
                    this.form.country_code = payload.countryCallingCode;
                }else{
                    this.form.country_code = null;
                }
            }
        },
        computed:{
        
        }
    }
</script>


